import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { pmMayOpenRoute } from '../../../src/services/team/roles';

const TABS: Array<{ to: string; label: string; key: string }> = [
  { to: '/', label: 'Dashboard', key: 'dashboard' },
  { to: '/reports', label: 'Reports', key: 'reports' },
  { to: '/sends', label: 'Sent to finance', key: 'sends' },
  { to: '/engagement-health', label: 'Engagement health', key: 'engagement-health' },
  { to: '/outreach', label: 'Outreach', key: 'outreach' },
  { to: '/sow', label: 'SOWs', key: 'sow' },
  { to: '/inbox', label: 'Replies', key: 'inbox' },
  { to: '/chemistry-checks', label: 'Chem checks', key: 'chemistry-checks' },
  { to: '/affiliates', label: 'Affiliates', key: 'affiliates' },
  { to: '/settings', label: 'Settings', key: 'settings' },
];

export function TopNav(): JSX.Element {
  const { displayName, signOut, role } = useAuth();
  // Project Managers only see the areas they can use.
  const tabs = role === 'pm' ? TABS.filter((t) => pmMayOpenRoute(t.to)) : TABS;
  const initials = displayName.split(' ').map((s) => s[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div className="nav">
      <div className="nav-brand">
        <span className="dot" />
        <span>Ariel</span>
        <span className="sep">Operations Reports</span>
      </div>
      <div className="nav-tabs">
        {tabs.map((t) => (
          <NavLink
            key={t.key}
            to={t.to}
            end={t.to === '/'}
            className={({ isActive }) => 'nav-tab' + (isActive ? ' active' : '')}
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="nav-user" onClick={signOut} title="Sign out">
        <span>{displayName}</span>
        <span className="avatar">{initials}</span>
      </div>
    </div>
  );
}
